import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import url from "@/utils/url";
import config from "@/utils/config";
import { authStateEnum, eventEnum } from "@/utils/enum";

class MobileAccountItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // SPメニューアカウント表示状態
      isAccountShow: false,
    };
  }

  // SPメニューアカウントショー/非表示
  toggleAccountShow = () => {
    const { isAccountShow } = this.state;
    this.setState({
      isAccountShow: !isAccountShow,
    });
  };

  // ログアウト
  logout = () => {
    config.eventEmitter.emitEvent(eventEnum.logout);
  };

  render() {
    const { isAccountShow } = this.state;
    const { headerInfo, t, authState, toggleMenuOpen } = this.props;
    return (
      <div className="flex-column sp-account-section">
        <div
          className={`flex-row-vertical-center sp-account-cell ${
            isAccountShow ? "open" : ""
          }`}
          onClick={this.toggleAccountShow}
        >
          <img
            className="sp-account-avatar"
            src={require("@/assets/images/dummy-avatar.svg")}
            alt=""
          />
          <span className="sp-account-name">
            {`${headerInfo?.companyName || ""} ${headerInfo?.userName || ""}`}
          </span>
          <i className="sp-account-dropdown-arrow"></i>
        </div>
        <div className="sp-account-menu">
          <RouterLink to={url.settingsCorpProfile} onClick={toggleMenuOpen}>
            {t("TCMS01002_companyProfile")}
          </RouterLink>
          <RouterLink to={url.settingsUserProfile} onClick={toggleMenuOpen}>
            {t("TCMS01002_userProfile")}
          </RouterLink>
          {authState === authStateEnum.auth0 && (
            <button className="sp-logout-button" onClick={this.logout}>
              {t("TCMS01002_logout")}
            </button>
          )}
        </div>
      </div>
    );
  }
}

MobileAccountItem.propTypes = {
  toggleMenuOpen: PropTypes.func,
};

MobileAccountItem.defaultProps = {
  toggleMenuOpen: undefined,
};

const mapStateToProps = (state) => {
  return {
    headerInfo: state.user.headerInfo,
    authState: state?.user?.authState,
  };
};

export default withTranslation()(connect(mapStateToProps)(MobileAccountItem));
